// extracted by css-extract-rspack-plugin
export default {"layout":"Commits-module__layout__DrciT"};